import { render, staticRenderFns } from "./FeeRegistrationForm.vue?vue&type=template&id=37052ac7&scoped=true&"
import script from "./FeeRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./FeeRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./FeeRegistrationForm.vue?vue&type=style&index=0&id=37052ac7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37052ac7",
  null
  
)

export default component.exports